// Preview bundle entry. Loads in BOTH backoffice and the standalone configurator
// preview HTML route. MUST stay free of @umbraco-cms/backoffice imports — see
// memory feedback_plugin_bundles_no_umbraco_imports. The designer (workspace-
// context-aware property-editor) lives in a separate bundle that only loads in
// backoffice.

import './stepdrill-preview.js';
import { registerItemRenderer } from '@ixit/dof-core';
import { html } from 'lit';

registerItemRenderer({
    itemType: 'stepdrill',
    // `operations` is a top-level property here rather than a wrapper blob — the one shape
    // difference between the three tools, and exactly why the designer must be TOLD rather than
    // left to infer. It is the same value StepdrillSchemaBuilder passes to ParseConfig.
    live: { elementTypeAlias: 'dofStepdrill', configProperty: 'operations' },
    render: (item, state, onInputChange) => html`
        <ixit-stepdrill-preview
            .item=${item as any}
            .state=${state as any}
            .onInputChange=${onInputChange}
        ></ixit-stepdrill-preview>
    `,
});
